import {
	animalFarm,
	churchOfPseudoscience,
	energyLeech,
	mulligan,
	recyclingPlant,
	selfImage,
	tieBreaker,
} from '@lc/const/modifiers';
import { createCardEquipment } from '@lc/interface/card/equipment/factory';

export const EquipmentMeta = [
	createCardEquipment(
		133,
		1,
		`SELF-IMAGE SACRIFICE`,
		`ON YOUR TURN, YOU MAY TAKE ENERGY FROM YOUR PR PILE AND PUT IT IN YOUR CUP`, // BUTTON ON CARD, 1 PER PRESS
		`“IT’S THE POWER WE NEED, NOT THE POWER WE DESERVE.”`,
		selfImage,
		false,
		false,
		false,
		true
	),
	createCardEquipment(
		134,
		1,
		`SELF-IMAGE SACRIFICE`,
		`ON YOUR TURN, YOU MAY TAKE ENERGY FROM YOUR PR PILE AND PUT IT IN YOUR CUP`, // BUTTON ON CARD, 1 PER PRESS
		`“IT’S THE POWER WE NEED, NOT THE POWER WE DESERVE.”`,
		selfImage,
		false,
		false,
		false,
		true
	),
	createCardEquipment(
		135,
		0,
		`TIEBREAKER`,
		`YOU WIN TIES FOR AWARDS`,
		`“YOU ALSO WIN THE AWARD FOR TIES.”`,
		tieBreaker // might just need to check for this equipment card in user posession during award resolution
	),
	createCardEquipment(
		// TODO may be too much for initial game
		136,
		0,
		`FARM OF ANIMALS`,
		`ONCE PER MONTH, YOU MAY PAY ONE (1) ENERGY TO DRAW A CARD. IF THE CARD IS AN EVENT, YOU MAY PLAY IT FOR FREE.`,
		`“SOME CARDS ARE MORE EQUAL THAN OTHERS.”`,
		animalFarm,
		false,
		false,
		false,
		true
	),
	createCardEquipment(
		137,
		0,
		`CHURCH OF PSEUDOSCIENCE`,
		`EACH TURN YOU MAY MOVE A PR TO A BATTERY`,
		`“SOMEBODY PLEASE SUE US, WE NEED THE PUBLICITY.”`,
		churchOfPseudoscience,
		false,
		false,
		false,
		true
	),
	createCardEquipment(
		138,
		2,
		`RECYCLING PLANT`,
		`ONCE PER MONTH, YOU MAY DISCARD A CARD TO DRAW A CARD`,
		`“WE JUST THROW IT ALL IN A PIT.”`,
		recyclingPlant,
		false,
		false,
		false,
		true
	),
	createCardEquipment(
		// TODO may be too much for initial game
		139,
		2,
		`ENERGY LEECH`,
		`CHOOSE A PLAYER. WHEN A CARD EFFECT WOULD CHARGE ONE OF THAT PLAYER’S BATTERIES, YOU CHARGE ONE (1) OF YOUR BATTERIES WITH THEIR COLOR ENERGY.`,
		`“DOESN’T SUCK TO SUCK.”`,
		energyLeech,
		false
	),
	createCardEquipment(
		// TODO may be too much for initial game
		140,
		2,
		`ENERGY LEECH`,
		`CHOOSE A PLAYER. WHEN A CARD EFFECT WOULD CHARGE ONE OF THAT PLAYER’S BATTERIES, YOU CHARGE ONE (1) OF YOUR BATTERIES WITH THEIR COLOR ENERGY.`,
		`“WHAT’S YOURS IS MINE.”`,
		energyLeech,
		false
	),
	createCardEquipment(
		141,
		1,
		`MULLIGAN`,
		`ONCE PER TURN, YOU MAY DISCARD TWO (2) UNUSED SUMMIT CARDS TO DRAW A NEW ONE`,
		`“WAIT.. IS THIS CHEATING? THIS FEELS LIKE CHEATING.”`,
		mulligan,
		false
	),
	createCardEquipment(
		// TODO may be too much for initial game
		142,
		1,
		`FAKE NEWS`,
		`YOU MAY DISCARD THIS CARD TO REPLACE A NEWS CARD THAT WAS JUST FLIPPED WITH A NEW NEWS CARD`,
		`“THAT’S NICE, BUT HERE’S HOW I REMEMBER IT HAPPENING.”`,
		``,
		false,
		true
	),
	createCardEquipment(
		// TODO may be too much for initial game
		143,
		1,
		`ALTERNATIVE FACTS`,
		`YOU MAY DISCARD THIS CARD AT ANY TIME TO NULLIFY AN EVENT OR PR CARD PLAYED BY ANOTHER PLAYER`,
		`“MY FAVORITE GENRE OF FACT.”`,
		``,
		false,
		true
	),
];
